module.exports = __webpack_public_path__ + "static/media/add-field.132ed197.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/gifs/add-field.gif
// module id = 2236
// module chunks = 0